import { Component, Input, OnChanges } from '@angular/core';
import { AuthService } from 'src/app/services/auth/auth.service';
import { LiquidacionService } from 'src/app/services/liquidacion/liquidacion.service';
import { claseMarca, fechaLiq, puedeVerLiquidacion } from 'src/app/services/liquidacion/marcas';

/**
 * RECUADRO «LIQUIDACIÓN AL COMERCIO» de un crédito (EST-01/02; maqueta traza-credito-pago, escenario 4).
 * Va en la ficha del crédito: lo esencial en una línea y el enlace a la traza completa en Consultas.
 * EST-08: sin `liquidacion.consultar` no se muestra y no llama al núcleo (que de todos modos responde 403).
 */
@Component({
  selector: 'app-liquidacion-marca-venta',
  templateUrl: './liquidacion-marca-venta.component.html'
})
export class LiquidacionMarcaVentaComponent implements OnChanges {
  /** El código de la venta (Invoice.code). */
  @Input() code: string | null = null;

  m: any = null;
  cargando = false;
  error = '';
  readonly claseMarca = claseMarca;
  fecha = (iso: string | null): string => fechaLiq(iso, true);

  constructor(private _auth: AuthService, private liq: LiquidacionService) { }

  get puede(): boolean { return puedeVerLiquidacion(this._auth); }

  ngOnChanges(): void { this.cargar(); }

  cargar = async (): Promise<void> => {
    this.m = null; this.error = '';
    if (!this.puede || !this.code) return;
    this.cargando = true;
    try { this.m = await this.liq.estadoVenta(this.code); }
    catch (e: any) { this.error = e?.status === 404 ? `El núcleo no encuentra la venta ${this.code}.` : (e?.error?.msg || 'No se pudo leer la liquidación de este crédito.'); }
    finally { this.cargando = false; }
  };

  /** La línea de texto: LIQ, día, pagado el / referencia (compra de deuda). La cobranza va con su avance aparte. */
  get linea(): string {
    const m = this.m;
    if (!m || m.modelo === 'COBRANZA') return '';
    const p: string[] = [];
    if (m.liquidacion) p.push(`Entró en ${m.liquidacion}${m.dia_cierre ? ` el ${this.fecha(m.dia_cierre)}` : ''}${m.arrastrada_el ? ` (se había arrastrado el ${this.fecha(m.arrastrada_el)} por neto negativo)` : ''}`);
    else if (m.estado === 'POR_LIQUIDAR' && m.vence) p.push(`Vence el ${this.fecha(m.vence)}: entra al cierre de ese día`);
    else if (m.cierre) p.push(`En ${m.cierre}${m.dia_cierre ? ` del ${this.fecha(m.dia_cierre)}` : ''}${m.veces_pasada ? ` · pasó a mañana ${m.veces_pasada} ${m.veces_pasada === 1 ? 'vez' : 'veces'}` : ''}`);
    if (m.pagado_el) p.push(`pagado el ${this.fecha(m.pagado_el)}${m.lote ? ` en ${m.lote}` : ''}${m.referencia ? `, ref. ${m.referencia}` : ''}`);
    else if (m.liquidacion) p.push(m.lote ? `en el lote ${m.lote}, por pagar` : `cuenta por pagar ${m.cuenta_por_pagar || '—'}, por pagar`);
    return p.join(' · ');
  }
}
